import * as React from "react";

import TextField from "@mui/material/TextField";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Check, Clear, ClearAll, Error, Send, Warning } from "@mui/icons-material";

import dayjs from "dayjs";
import { sendBulkMessage } from "../data/API";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function createData(name, date) {
  return { name, date };
}

const rows = [
  createData("Ali", "1/5/2023"),
  createData("Mohammad", "1/5/2023"),
  createData("Mostofa", "1/5/2023"),
  createData("Nasi", "1/5/2023"),
  createData("Jameel", "1/5/2023"),
];



export default function BulkNew() {
  const notifyToast =(message)=>{
    toast(message);
  }
  const [selectedOption, setSelectedOption] = React.useState("users");
  const [message, setMessage] = React.useState("");

    function sendBulk(){
        if(message!==''){
            sendBulkMessage(selectedOption,message,(err,data)=>{
              if(err){
                setToastIcon(<Error sx={{color:'red'}}/>)
                  notifyToast('Something went wrong!');
              }else{
                notifyToast(data['message']);
              }
            })
        }
    }

    const [toastIcon ,setToastIcon] = React.useState(<Check  sx={{color:"green"}}/>);


  return (
    <div
      style={{ height: window.innerHeight / 1.25, overflowX: "auto" }}
      className="px-1"
    >
      <ToastContainer  icon={toastIcon} />
      <div
        className="flex p-1 gap-4 mt-4"
        style={{
          boxShadow: "0px 0px 2px 1px rgba(0,0,0,0.2)",
          padding: "10px",
          borderRadius: "10px",
          flexDirection: "column",
        }}
      >
        Send To
        <RadioGroup
          aria-label="options"
          title="Send To"
          value={selectedOption}
          onChange={(e) => setSelectedOption(e.target.value)}
        >
          <FormControlLabel
            defaultChecked={true}
            value="users"
            control={<Radio />}
            label="All Users"
          />
          <FormControlLabel
            value="agents"
            control={<Radio />}
            label="All Agents"
          />
          <FormControlLabel
            value="kitchens"
            control={<Radio />}
            label="All Kitchens"
          />
        </RadioGroup>
      </div>
      <div
        className="flex flex-row p-1 gap-1 mt-8"
        style={{
          boxShadow: "0px 0px 2px 1px rgba(0,0,0,0.2)",
          padding: "10px",
          borderRadius: "10px",
        }}
      >
        <div className="flex-1">
          <p
            style={{
              fontWeight: "600",
              color: "green",
              fontSize: "16px",
              marginBottom: "10px",
              marginTop: "2px",
            }}
          >
            BULK SELECTION:{" "}
            <span style={{ color: "black" }}>{selectedOption}</span>
          </p>
          <TextField
            label="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type Here"
            variant="outlined"
            className="w-full"
            id="outlined-multiline-static"
            multiline
            rows={7}
          />
          <div className="flex mt-3  justify-end gap-3">
            <Button
              color={"error"}
              variant="contained"
              sx={{ paddingX: "13px" }}
            >
              <ClearAll sx={{ marginInlineEnd: "4px" }} /> Clear
            </Button>
            {/* <Button
              color={"warning"}
              variant="contained"
              sx={{ paddingX: "13px" }}
            >
              <Drafts sx={{ marginInlineEnd: "10px" }} /> Draft
            </Button> */}
            <Button
              color={"success"}
              onClick={sendBulk}
              variant="contained"
              sx={{ paddingX: "13px" }}
            >
              Send <Send sx={{ marginInlineStart: "10px" }} />
            </Button>
          </div>
        </div>
        <div
          style={{
            width: "1px",
            background: "rgba(0, 0, 0, 0.2)",
            borderRadius: "15px",
            marginInlineStart: "5px",
            marginInlineEnd: "5px",
          }}
        />

        <div style={{ flex: 1 }} className=" flex flex-col gap-2">
          <div className="flex h-200 flex-row gap-2">
            <TextField
              size="small"
              label="Compaign Name"
              placeholder="Type Here"
              variant="outlined"
              id="outlined-multiline-static"
            />
          </div>
          <div className="flex h-200 flex-row gap-2">
            <TextField
              size="small"
              label="Dated (Today)"
              variant="outlined"
              InputProps={{
                readOnly: true,
              }}
              defaultValue={dayjs(new Date()).format("DD/MM/YYYY")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
